export default __webpack_public_path__ + "backIcon.svg";